/** 
 * @type {import("./defs").StoreProjectValuation} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreProjectValuation} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectValuation.js